import React, { Component } from 'react';
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import { Row, Col, Button, Table } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { addDays } from 'date-fns';
import moment from "moment";
import DoubleScreen from './DoubleScreen';
export default class WebFormSearch extends Component {
  constructor(props){
    super(props)
    this.state= {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      saveClicked:false
    }
    this.title=""
  }
  componentDidMount = () =>{
    this.props.function.actioninventoryUserMapped()
  }
  componentWillMount = () => {  
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){      
      let regionNames = _.filter(inventory);
      this.setState({selectedregionName:regionNames[0]})
    }    
  }
  regionNames = () => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
    let regionNames = _.filter(inventory); 
    return regionNames;
    }
    
  }
  
  centerNames = () => {
    const{selectedregionName} = this.state;
    if(!_.isEmpty(selectedregionName)){    
        let centerName = _.filter(selectedregionName.userCenters);
        return centerName;
    }
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    let clientName=[];
    if(!_.isEmpty(selectedcenterName)){
    _.map(selectedcenterName, (obj)=>{
        let x = _.filter(obj.userClients);
        clientName.push(...x );
        this.bulkclientName=clientName
    }) 
    return  _.uniqBy(clientName, 'inventoryClientId');
    }
  }
  processNames = () => {
    const{selectedclientName} = this.state;
    let processName=[];
    if(!_.isEmpty(selectedclientName)){
      _.map(selectedclientName, (obj)=>{
          let abc = _.filter(this.bulkclientName, {'inventoryClientId':obj.inventoryClientId})
          _.map(abc, (z) => {
            processName.push(...z.userProcesses)
            processName = _.uniqBy(processName, 'inventoryProcessId');
          })
      })    
    }
    return processName;
  }
  handleSelect = (e) => {
    this.setState({selectedregionName: e});
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[]})
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedclientName:[], selectedprocessName:[]})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedprocessName:[]})
    }
  }
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});  
  }
  handleChangeStart = (date) => {
   // date.setMinutes( date.getMinutes() + date.getTimezoneOffset() );
    this.setState({startDate: date});
    
    if(!_.isEqual(this.state.startDate, date)){
      this.setState({endDate:''})
    }
  }
  handleChangeEnd = (e) => {
   // e.setMinutes( e.getMinutes() + e.getTimezoneOffset() );
    this.setState({endDate: e});
  }
 
  handleDoubleClick = (i) => { 
    this.setState({['showDouble'+i]:true})
  }
  onClose = (i) => {
    this.setState({['showDouble'+i]:false})
  }
  renderInboxValues = (data) => { 
    if(!_.isEmpty(data)){
     return _.map(data, (obj, index) =>{  
        return(
        <tr onDoubleClick={()=>this.handleDoubleClick(index)}>
          {this.state['showDouble'+index] ? <DoubleScreen closeModal={()=>this.onClose(index)} object={obj} title={this.title}
          function={this.props.function} 
            /> 
          : null}
          <td>{obj.transactionID}</td>
          <td>{obj.addedDate}</td>        
          <td>{obj.webFormName}</td>    
          <td>{obj.QAName}</td>
        </tr>)                     
      })
    } else {
      return(<tr><td colSpan="4">No Records Found</td></tr>)
    }
  }
  validateForm = () =>{    
    const {startDate, endDate, selectedregionName,selectedcenterName, selectedclientName, selectedprocessName} = this.state;
      if((typeof startDate !== 'undefined')  && (typeof endDate !== 'undefined') && !_.isEmpty(selectedregionName)
      && !_.isEmpty(selectedcenterName) && !_.isEmpty(selectedclientName) && !_.isEmpty(selectedprocessName)){
        return true }
    }
  SearchTemplate = () => {  
    this.props.function.resetsearchData()
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, startDate, endDate} = this.state;
    let center = _.map(selectedcenterName, (x) =>{return x.inventoryCenterName}).join(',')
    let clients = _.map(selectedclientName, (x) =>{return x.inventoryClientName}).join(',')
    let process = _.map(selectedprocessName, (x) =>{return x.inventoryProcessName}).join(',')
    let obj = {
      'region': {'regionId':selectedregionName.inventoryRegionId, 'regionName':selectedregionName.inventoryRegionName},
      'centerIds': _.map(selectedcenterName, (x) =>{return x.inventoryCenterId}),
      'clientIds': _.map(selectedclientName, (x) =>{return x.inventoryClientId}),
      'processIds': _.map(selectedprocessName, (x) =>{return x.inventoryProcessId}),
     'startDate':moment(startDate).format('YYYY-MM-DD'),
     'endDate':moment(endDate).format('YYYY-MM-DD'),
    }
    this.title = selectedregionName.inventoryRegionName+" / "+center+" / "+clients+" / "+process
    this.props.function.TokenValidation()    
    this.props.function.WebFormSearchCompleted(obj)
    this.setState({search:true})
  }
  resetTemplate = () =>{
    this.setState({
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      startDate:null,
      endDate:null,
      search:false,
      activePage:1
    })
  }
  render(){
    const {search} = this.state;
    return(
    <div>
      <Row>
      <Col>
        <label>Region Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
        value={this.state.selectedregionName}
        options={this.regionNames()}
        onChange={this.handleSelect}
        open={false}
        valueKey="inventoryRegionName"
        labelKey="inventoryRegionName"
        multiple={false}
        includeSelectAll={false}
        includeFilter={false}
        placeholder='Select Region'
        dropdownHeight={600}
      />
      </Col>
    </Row> 
      <Row>
      <Col>
        <label>Center Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
        value={this.state.selectedcenterName}
        options={this.centerNames()}
        onChange={this.handleSelectCenter}
        open={false}
        valueKey="inventoryCenterName"
        labelKey="inventoryCenterName"
       multiple={true}
        includeSelectAll={false}
        includeFilter={false}
        placeholder='Select Center'
        dropdownHeight={600}
      />
      </Col>             
    </Row>
      <Row>
      <Col>
        <label>Client Name</label>
      </Col>
      <Col>
    <Picky keepOpen={false}
      value={this.state.selectedclientName}
      options={this.clientNames()}
      onChange={this.handleSelectClient}
      open={false}
      valueKey="inventoryClientName"
      labelKey="inventoryClientName"
     multiple={true}
      includeSelectAll={false}
      includeFilter={false}
      placeholder='Select Client'
      dropdownHeight={600}
    />
    </Col>
    </Row> 
      <Row>
      <Col>
      <label>Process Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
      value={this.state.selectedprocessName}
      options={this.processNames()}
      onChange={this.handleSelectProcess}
      open={false}
      valueKey="inventoryProcessName"
      labelKey="inventoryProcessName"
     multiple={true}
      includeSelectAll={false}
      includeFilter={false}
      placeholder='Select Process Name'
      dropdownHeight={600}
    />
     </Col>
     </Row> 
      <Row>
        <Col>
        <label>Date Range<span className='RedColoring'>*</span></label>
       </Col>
        <Col className='myContainter'>
        <DatePicker
           selected={this.state.startDate}
           className='myDatePicker'
           selectsStart
           showMonthDropdown
           startDate={this.state.startDate}
           endDate={this.state.endDate}
           onChange={this.handleChangeStart}
           maxDate={addDays(this.state.startDate, 14)}
           placeholderText="Select a date Range"
          />
        <DatePicker
          selected={this.state.endDate}
          selectsEnd
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onChange={this.handleChangeEnd}
          minDate={this.state.startDate}
          maxDate={addDays(this.state.startDate, 14)}
          placeholderText="Select a date Range"
          />    
       </Col> 
     </Row> 
      <br/>
     <center><Button onClick={this.SearchTemplate} className='buttonwidth' disabled={!this.validateForm()}>Search</Button>&nbsp;
     <Button onClick={this.resetTemplate} className='buttonwidth'>Reset</Button>     
     </center>
        {((search)) ?  
        <p className='calibration'>
        <Table responsive>
          <thead>
            <th>TRANSACTION NO</th>              
            <th>TRANSACTION DATE</th> 
            <th>WEB FORM NAME</th>
            <th>UPDATED BY</th>
          </thead>
          <tbody>
          {this.renderInboxValues(this.props.searchReport)}  
          </tbody>
        </Table>
       
       
       </p>: null}      
  </div>)
  }
}